import { render, staticRenderFns } from "./UButton.vue?vue&type=template&id=6a25d3f6"
import script from "./UButton.vue?vue&type=script&lang=js"
export * from "./UButton.vue?vue&type=script&lang=js"
import style0 from "./UButton.vue?vue&type=style&index=0&id=6a25d3f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports